import { CircularProgress } from "@material-ui/core"
import React from "react"
import { Link } from "react-router-dom"

const DashboardHero = ({
  name,
  date,
  progressValue,
  cashValue,
  giftValue,
  registry
}) => {
  return (
    <div className="flex items-start justify-between flex-wrap">
      <div className="max-w-3xl w-2/5 dash-hero-img h-48 flex justify-center px-12 flex-col medium:w-full medium:mb-5">
        <h1 className="self-end text-white font-medium text-3xl">
          Welcome {`${name}`}
        </h1>
        <h1 className="self-end justify-self-center mt-1 font-medium text-xl">
          {date}{" "}
        </h1>
      </div>

      <div>
        <div className="w-96 bg-sbg-white rounded-xl shadow-lg px-4 py-7 flex justify-between items-center medium:w-full medium:self-center">
          <div>
            <h1 className="text-xl text-black font-medium">Cash Gifts</h1>
            <h2 className="text-md text-sbg-grey mt-1">Value of cash gifts</h2>
          </div>

          <img src={require("../../assets/cash.svg").default} alt="cash" />
          <div>
            <h4 className="bg-sbg-light-green px-2 py-2 w-20 text-left text-white rounded-3xl">
              {" "}
              <span className="font-extrabold">&#8226;</span> Cash
            </h4>
            <h3 className="font-medium mt-1"> &#x20a6; {cashValue}</h3>
          </div>
        </div>

        <div className="w-96 bg-sbg-white rounded-xl shadow-lg px-4 py-7 flex justify-between items-center my-4 medium:w-full medium:self-center">
          <div>
            <h1 className="text-xl text-black font-medium">Gifts Received</h1>
            <h2 className="text-md text-sbg-grey mt-1">Number of received</h2>
          </div>

          <img src={require("../../assets/gift-box.svg").default} alt="cash" />
          <div>
            <h4 className="bg-sbg-purple px-2 py-2 w-20 text-left text-white rounded-3xl">
              {" "}
              <span className="font-extrabold">&#8226;</span> Gifts{" "}
            </h4>
            <h3 className="font-medium mt-1"> &#x20a6; {giftValue}</h3>
          </div>
        </div>

        {/* {registry && (
          <Link className="flex items-center" to={`/registry/${registry[0]}`}>
            <img
              src={require("../../assets/preview.svg").default}
              alt="settings"
              className="mr-2 h-5"
            />
            <p className="text-lg text-sbg-grey">Preview registry</p>
          </Link>
        )} */}
      </div>

      {/* SECTION FOR THE IMPLEMENTATION OF THE ARC */}

      <div className="w-72 h-64 relative  medium:w-full ">
        <CircularProgress
          variant="determinate"
          value={progressValue < 3 ? "3" : `${progressValue}`}
          classes={{
            root: "circle",
            circle: "circle-svg"
          }}
        />

        <h3 className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center font-medium text-xl">
          {progressValue}% Complete
        </h3>
        <img
          src={require("../../assets/clouds.svg").default}
          alt="cloud"
          className="w-4/6 mx-auto mt-5"
        />
      </div>
    </div>
  )
}

export default DashboardHero
